import { Edit, SimpleForm, TextInput, SelectInput } from 'react-admin';
import { Box, Typography } from '@mui/material';

export const ServiceAuthorisationEdit = () => (
  <Edit>
    <SimpleForm>
      <Typography variant="h6" sx={{ mb: 1 }}>Authorisation Details</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1 }}>
        <TextInput source="authorisationNumber" label="Authorisation Number" fullWidth />
        <TextInput source="serviceId" label="Service ID" fullWidth />
        <TextInput source="clientId" label="Client ID" fullWidth />
        <TextInput source="referenceNumber" label="Reference Number" fullWidth />
        <TextInput source="validFrom" type="date" fullWidth />
        <TextInput source="validUntil" type="date" fullWidth />
        <SelectInput
          source="status"
          choices={['Pending', 'Active', 'Expired', 'Revoked'].map(s => ({ id: s, name: s }))}
          fullWidth
        />
      </Box>
      <TextInput source="description" multiline rows={3} fullWidth sx={{ mt: 1 }} />
      <TextInput source="termsAndConditions" label="Terms & Conditions" multiline rows={3} fullWidth sx={{ mt: 1 }} />
    </SimpleForm>
  </Edit>
);
